import React, { createContext, useContext } from "react";

export interface ShiftSearchFilterOptions {
	all: boolean;
	outOfService: boolean;
	handoverEvent: boolean;
}

export interface ShiftPageContextValue {
	searchInput: string;
	setSearchInput: (v: string) => void;
	openRegister: boolean;
	setOpenRegister: (v: boolean) => void;
	selectedGroup: string;
	setSelectedGroup: (v: string) => void;
	groupIdOrUndefined: number | undefined;
	/** Search tab filters (Start date, End date, checkboxes) */
	startFromUtc: string;
	setStartFromUtc: (v: string) => void;
	endAtUtc: string;
	setEndAtUtc: (v: string) => void;
	searchFilterOptions: ShiftSearchFilterOptions;
	setSearchFilterOptions: React.Dispatch<
		React.SetStateAction<ShiftSearchFilterOptions>
	>;
}

const ShiftPageContext = createContext<ShiftPageContextValue | null>(null);

export const ShiftPageContextProvider = ShiftPageContext.Provider;

export function useShiftPage() {
	const ctx = useContext(ShiftPageContext);
	if (!ctx)
		throw new Error(
			"useShiftPage must be used within ShiftPageContext.Provider",
		);
	return ctx;
}
